import { useState, useCallback, useEffect } from 'react';
import { initializeAddCredBannerState, setLocalStorageForAddCredBanner } from '../utils/utils';

export const usePayerCredBanner = (isEligible: boolean) => {
  const [showBanner, setShowBanner] = useState(() => initializeAddCredBannerState(isEligible));
  useEffect(() => {
    setShowBanner(initializeAddCredBannerState(isEligible));
  }, [isEligible]);

  const handleCloseBanner = useCallback(() => {
    setShowBanner(false);
    setLocalStorageForAddCredBanner();
  }, []);

  return { showBanner, handleCloseBanner };
};
